import PropTypes from "prop-types";
import MDButton from "components/MDButton";

function AgriActionButton({ children, variant, color, ...rest }) {
  return (
    <MDButton
      variant={variant}
      color={color}
      sx={{
        borderRadius: "14px",
        minHeight: "42px",
        px: 2.25,
        fontSize: "0.8rem",
        fontWeight: 700,
        letterSpacing: "0.02em",
        textTransform: "none",
      }}
      {...rest}
    >
      {children}
    </MDButton>
  );
}

AgriActionButton.defaultProps = {
  variant: "contained",
  color: "primary",
};

AgriActionButton.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(["text", "contained", "outlined", "gradient"]),
  color: PropTypes.oneOf([
    "white",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
};

export default AgriActionButton;
